module.exports = __webpack_public_path__ + "img/20110201_02.98524e86.jpg";